import { alertMessageConfirmDeleteAddressHappy, alertMessageConfirmDeleteAddressHappyEmpty } from "@/happyTheme/event/dashboard/address/alertMessageConfirmDeleteAddressHappy"
import { alertMessageDeleteAddressHappy, alertMessageDeleteAddressHappyEmpty } from "@/happyTheme/event/dashboard/address/alertMessageDeleteAddressHappy"
import { TimeOutClass } from "@/happyTheme/services/timeout/TimeOutClass"
import type { Ref } from "vue"

export function toggleAlertDeleteAddressHappy(isVisible: Ref<boolean>) {
    const timeOutClear = TimeOutClass.getInstance()
    timeOutClear.clearIdTimeout()

    isVisible.value = false
    alertMessageConfirmDeleteAddressHappy.value =
        alertMessageConfirmDeleteAddressHappyEmpty
    const idTimeOut = setTimeout(() => {
        alertMessageDeleteAddressHappy.value = alertMessageDeleteAddressHappyEmpty
    }, 300)
    const timeOut = TimeOutClass.getInstance()
    timeOut.setIdTimeout(idTimeOut)
}